<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">任务颗粒度</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 开发完成时间</p>
            <p>描述: 所选时间段内各团队或个人负责任务的平均任务点数，平均任务点数 = Point总数 / 任务</p>
            <p>排序: 平均任务点数正序（默认）</p>
            <p>操作: 点击右上角团队/个人可切换查看视角<cursor /></p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div slot="extra">
        <a-radio-group v-model="showModal" button-style="solid" size="small" @change="onChange">
          <a-radio-button value="team"> 团队 </a-radio-button>
          <a-radio-button value="person"> 个人 </a-radio-button>
        </a-radio-group>
      </div>
      <div id="task-point-average" :style="{ height: height, width: width }" />
    </a-card>
  </div>
</template>
<script>
import { taskPointRank } from '@/api/data/task';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'team',
      loading: true,
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {
          max: function (value) {
            return value.max > 5 ? Math.ceil(value.max) : 5;
          }
        },
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            endValue: 18
          }
        ]
      },
      data: []
    };
  },
  watch: {
    filterForm() {
      this.getTaskPointRank();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/line');
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(document.getElementById('task-point-average'));
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    onChange(e) {
      this.utils.trackClick({ name: '任务颗粒度切换', label: e.target.value === 'team' ? '团队' : '个人' });
      this.getTaskPointRank();
    },
    getTaskPointRank() {
      this.loading = true;
      taskPointRank({ ...this.filterForm, sorter: 'point_average', show_modal: this.showModal })
        .then(res => {
          this.data = res.data.items;
          const x_axis = [];
          const point_average_series = [];
          this.data.forEach(el => {
            x_axis.push(this.showModal === 'team' ? el.team_name : el.nickname);
            point_average_series.push(el.point_average);
          });

          this.option.xAxis.data = x_axis;
          this.option.series = [
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '平均任务点数',
              data: point_average_series,
              markLine: {
                data: [{ yAxis: 4.0 }]
              }
            }
          ];
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
</style>
